import React, { useEffect, useState } from 'react';
import { tenantService } from '../services/tenantService';
import toast from 'react-hot-toast';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const data = await tenantService.getStats();
      setStats(data);
    } catch (error) {
      toast.error('Failed to load statistics');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <StatCard
          title="Total Clinics"
          value={stats?.total_tenants || 0}
          icon="🏥"
          color="bg-blue-500"
        />
        <StatCard
          title="Active Clinics"
          value={stats?.active_tenants || 0}
          icon="✅"
          color="bg-green-500"
        />
        <StatCard
          title="Trial Clinics"
          value={stats?.trial_tenants || 0}
          icon="🆓"
          color="bg-yellow-500"
        />
        <StatCard
          title="Suspended"
          value={stats?.suspended_tenants || 0}
          icon="⏸️"
          color="bg-red-500"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <RevenueCard
          title="Total Revenue"
          value={stats?.total_revenue || 0}
          icon="💰"
        />
        <RevenueCard
          title="Monthly Plans"
          value={stats?.monthly_revenue || 0}
          icon="📅"
        />
        <RevenueCard
          title="Yearly Plans"
          value={stats?.yearly_revenue || 0}
          icon="📆"
        />
      </div>
    </div>
  );
}

function StatCard({ title, value, icon, color }) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-600 text-sm">{title}</p>
          <p className="text-3xl font-bold mt-2">{value}</p>
        </div>
        <div className={`${color} text-white text-4xl p-4 rounded-full`}>
          {icon}
        </div>
      </div>
    </div>
  );
}

function RevenueCard({ title, value, icon }) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center gap-3 mb-2">
        <span className="text-2xl">{icon}</span>
        <h3 className="text-gray-600 text-sm">{title}</h3>
      </div>
      <p className="text-2xl font-bold text-green-600">
        ₹{value.toLocaleString('en-IN')}
      </p>
    </div>
  );
}

export default Dashboard;
